import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table_search mb-3 d-flex justify-content-end align-items-center" }
const _hoisted_2 = { class: "d-flex gap-2 align-items-center ms-auto" }
const _hoisted_3 = { class: "table-responsive data-table theme-scrollbar zero-configuration" }
const _hoisted_4 = {
  class: "display table dataTable no-footer table-bordered fix-wrap",
  id: "basic-1"
}
const _hoisted_5 = { class: "table-dark" }
const _hoisted_6 = ["sortable", "onClick"]
const _hoisted_7 = {
  key: 0,
  style: {"width":"260px"},
  class: "col-actions"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_13 = {
  key: 0,
  class: "col-actions border-0"
}
const _hoisted_14 = { class: "action_btns d-flex gap-2 justify-content-cneter" }
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = ["onClick", "disabled"]
const _hoisted_17 = ["onClick", "disabled"]
const _hoisted_18 = { class: "tabler_footer d-flex gap-3 justify-content-end align-items-center mt-2" }
const _hoisted_19 = { class: "d-flex align-items-center gap-2 align-items-center" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "pagination justify-content-end pagination-primary" }
const _hoisted_22 = {
  class: "page-item",
  style: { cursor: 'pointer' }
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "page-link" }
const _hoisted_25 = {
  class: "page-item",
  style: { cursor: 'pointer' }
}

import { ref, onMounted, watchEffect, defineAsyncComponent } from "vue";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonTable',
  props: ["tableObj", "title", "permissionKey"],
  emits: ["isActive", "edit", "delete", "view"],
  setup(__props, { emit: __emit }) {

const { canView, canUpdate, canDelete } = usePermissions();

const Card1 = defineAsyncComponent(() => import("@/components/commen/card/cardData1.vue"));
const emit = __emit;

let title = ref("");
const elementsPerPage = ref<number>(10); // default rows per page
const currentPage = ref<number>(1);
const filterQuery = ref<string>("");
const allData = ref([]);
const props = __props;

const sortOrder = ref("asc");
const sortedColumn = ref(null);
const columns = ref([]);
const actions = ref([]);

onMounted(() => {
    allData.value = props.tableObj?.data;
    columns.value = props.tableObj.columns;
    actions.value = props.tableObj.actions ? props.tableObj.actions : [];
    title.value = props.title;
});

watchEffect(() => {
    const source = props.tableObj?.data || [];
    const query = filterQuery.value.toLowerCase();
    if (query) {
        allData.value = source.filter((row) =>
            Object.values(row).some((val) =>
                val?.toString().toLowerCase().includes(query)
            )
        );
    } else {
        allData.value = source;
    }
});

// Pagination
function get_rows() {
    const start = (currentPage.value - 1) * elementsPerPage.value;
    const end = start + elementsPerPage.value;
    return allData.value.slice(start, end);
}
function num_pages() {
    return Math.ceil(allData.value.length / elementsPerPage.value);
}
function change_page(page: number) { currentPage.value = page; }
function change() { if (currentPage.value < num_pages()) currentPage.value++; }
function prev() { if (currentPage.value > 1) currentPage.value--; }

// Sorting
function sortTable(column: string) {
    if (sortedColumn.value === column) sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
    else sortedColumn.value = column, sortOrder.value = "asc";

    allData.value.sort((a, b) => {
        const aValue = a[column];
        const bValue = b[column];
        if (aValue < bValue) return sortOrder.value === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder.value === "asc" ? 1 : -1;
        return 0;
    });
}

// Row actions
function editRow(row) { emit("edit", row); }
function viewRow(row) { emit("view", row); }
function deleteRow(index) { emit("delete", index); }

// Export
function exportJSON() {
    const blob = new Blob([JSON.stringify(allData.value, null, 2)], { type: "application/json" });
    saveAs(blob, "table-data.json");
}
function exportCSV() {
    const ws = XLSX.utils.json_to_sheet(allData.value);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "table-data.csv");
}
function exportExcel() {
    const ws = XLSX.utils.json_to_sheet(allData.value);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "table-data.xlsx");
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "mb-3 d-flex gap-2" }, [
      _createElementVNode("button", {
        class: "btn btn-primary btn-sm",
        onClick: exportJSON
      }, "Export JSON"),
      _createElementVNode("button", {
        class: "btn btn-success btn-sm",
        onClick: exportCSV
      }, "Export CSV"),
      _createElementVNode("button", {
        class: "btn btn-warning btn-sm",
        onClick: exportExcel
      }, "Export Excel")
    ]),
    _createVNode(_unref(Card1), {
      colClass: "col-sm-12",
      cardhaderClass: "pb-0 pb-0 card-no-border",
      pre: "f-m-light mt-1",
      title: _unref(title),
      span: "true",
      spanClass: _ctx.desc
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "table-complete-search",
              class: "col-form-label"
            }, "Search:", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "table-complete-search",
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterQuery).value = $event))
            }, null, 512), [
              [_vModelText, filterQuery.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", _hoisted_5, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"70px"}
                }, "Sr No", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: index,
                    sortable: column.sortable,
                    onClick: ($event: any) => (sortTable(column.field)),
                    style: _normalizeStyle({
                                cursor: column.sortable ? 'pointer' : 'default',
                                width: column.width || 'auto'
                            })
                  }, _toDisplayString(column.name), 13, _hoisted_6))
                }), 128)),
                (actions.value[0])
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Action"))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!get_rows().length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      valign: "top",
                      colspan: columns.value.length + (actions.value[0] ? 2 : 1),
                      class: "dataTables_empty"
                    }, " No matching records found ", 8, _hoisted_9)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_rows(), (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column, colIndex) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: colIndex,
                          class: "wrap-cell"
                        }, [
                          (column.field === 'icon')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (typeof row[column.field] === 'string')
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: row[column.field],
                                      alt: "icon",
                                      style: {"width":"30px","height":"30px","object-fit":"cover","border-radius":"4px"}
                                    }, null, 8, _hoisted_11))
                                  : (row[column.field]?.iconName && row[column.field]?.prefix)
                                    ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                        key: 1,
                                        icon: [row[column.field].prefix, row[column.field].iconName],
                                        class: "fs-4 text-dark"
                                      }, null, 8, ["icon"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(row[column.field]), 1)
                              ], 64))
                        ]))
                      }), 128)),
                      (actions.value[0])
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-primary",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (viewRow(row)),
                                disabled: __props.permissionKey && !_unref(canView)(__props.permissionKey)
                              }, [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "icofont icofont-eye-alt" }, null, -1)
                              ]))], 8, _hoisted_15),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-success",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (editRow(row)),
                                disabled: __props.permissionKey && !_unref(canUpdate)(__props.permissionKey)
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "icofont icofont-edit" }, null, -1)
                              ]))], 8, _hoisted_16),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-danger",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (deleteRow(row._id)),
                                disabled: __props.permissionKey && !_unref(canDelete)(__props.permissionKey)
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                              ]))], 8, _hoisted_17)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-nowrap" }, "Rows per page:", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((elementsPerPage).value = $event)),
                class: "form-select outline-none"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([10, 25, 50, 100], (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_20)
                }), 64))
              ], 512), [
                [_vModelSelect, elementsPerPage.value]
              ])
            ]),
            _createElementVNode("ul", _hoisted_21, [
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("a", {
                  class: "page-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (prev())),
                  "aria-label": "Previous"
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("span", { "aria-hidden": "true" }, "«", -1)
                ]))])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(num_pages(), (i) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["page-item", [i == currentPage.value ? 'active' : '']]),
                  style: { cursor: 'pointer' },
                  key: i,
                  onClick: ($event: any) => (change_page(i))
                }, [
                  _createElementVNode("a", _hoisted_24, _toDisplayString(i), 1)
                ], 10, _hoisted_23))
              }), 128)),
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("a", {
                  class: "page-link",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (change())),
                  "aria-label": "Next"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("span", { "aria-hidden": "true" }, "»", -1)
                ]))])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "spanClass"])
  ], 64))
}
}

})